import { connect } from 'react-redux';
import { upperFirst } from 'lodash';
import i18next from 'i18next';
import React, { useMemo, useState } from 'react';

import { ListView, Button } from '@commons/utils/styledLibraryComponents';
import EmptyState from '@commons/EmptyState';

import { getClientInfo } from '@selectors/client';

import { getFeaturesModalColumns } from '../../utils/getFeaturesModalColumns';
import { useRoleModalFilters } from '../../utils/useRoleModalFilters';

import RoleModalFilterButton from '../RoleModalFilterButton';

import {
  Container,
  Header,
  HeaderTitle,
  CloseImage,
  ListViewContainer,
  Footer,
} from './styledComponents';

const FeaturesAddOrRemoveAssociationModal = (props) => {
  const {
    params: { role, closeModal, features, handleSave, isAssociation },
    client: { hasCentralKitchens },
  } = props;

  const [selectedItems, setSelectedItems] = useState([]);

  const columns = useMemo(() => getFeaturesModalColumns(hasCentralKitchens), [hasCentralKitchens]);

  const filtersState = useRoleModalFilters(features, columns);
  const { filteredData, columnsFilterList } = filtersState;

  return (
    <Container>
      <Header>
        <HeaderTitle>
          {i18next.t(
            isAssociation
              ? 'BACKOFFICE.ROLES.PAGE_ASSOCIATION_TO_ROLE'
              : 'BACKOFFICE.ROLES.PAGE_DISSOCIATION_TO_ROLE',
            { role: upperFirst(role.name) },
          )}
        </HeaderTitle>
        <CloseImage src="/images/inpulse/close-black-small.svg" onClick={() => closeModal()} />
      </Header>
      <ListViewContainer>
        <ListView
          columns={columns}
          data={filteredData}
          defaultOrderBy={'name'}
          defaultOrderType={'asc'}
          disableFooter={true}
          forceEnableSelection={true}
          padding={'24px 24px 0px 24px'}
          placeholderShape={i18next.t('GENERAL.SEARCH')}
          renderEmptyState={() => <EmptyState label={i18next.t('GENERAL.NO_RESULT')} />}
          renderFilterButton={() => (
            <RoleModalFilterButton
              columnsFilterList={columnsFilterList}
              filtersState={filtersState}
            />
          )}
          setSelectedItems={(items) => setSelectedItems(items)}
        />
      </ListViewContainer>
      <Footer>
        <Button
          color={'inpulse-outline'}
          handleClick={() => closeModal()}
          icon="/images/inpulse/close-black-small.svg"
          label={i18next.t('GENERAL.CANCEL')}
        />
        <Button
          buttonCustomStyle={{ marginLeft: 24 }}
          color={'inpulse-default'}
          handleClick={() => handleSave(selectedItems, role.id)}
          icon="/images/inpulse/save-white-small.svg"
          isDisabled={!selectedItems.length}
          label={i18next.t('GENERAL.SAVE')}
        />
      </Footer>
    </Container>
  );
};

const mapStateToProps = (state) => ({
  client: getClientInfo(state.baseReducer.user),
});

export default connect(mapStateToProps)(FeaturesAddOrRemoveAssociationModal);
